import React from 'react';
import './index.css';
import DemoHeader from './DemoHeader';
import HeroSection from './HeroSection';
import CategorySection from './CategorySection';
import TransformationSection from './TransformationSection';
import MultipleFormatsSection from './MultipleFormatsSection';
import StudioDemandSection from './StudioDemandSection';
import DemoFooter from './DemoFooter';

const DemoPage = () => {
  return (
    <div className="new-demo-page-container">
      <DemoHeader />
      <HeroSection />
      <CategorySection />
      <TransformationSection />
      <MultipleFormatsSection />
      <StudioDemandSection />
      <DemoFooter />
    </div>
  );
};

export default DemoPage;
